import find from 'lodash/find';
import get from 'lodash/get';
import set from 'lodash/set';
import camelCase from 'lodash/camelCase';
import isArray from 'lodash/isArray';
import findIndex from 'lodash/findIndex';
import mapKeys from 'lodash/mapKeys';
import forOwn from 'lodash/forOwn';
import { arrayed } from './array';
import last from 'lodash/array';
import keys from 'lodash/keys';
import values from 'lodash/values';
import uniq from 'lodash/uniq';
import isFunction from 'lodash/isFunction';
import sortBy from 'lodash/sortBy';
import clone from 'lodash/clone';
import cloneDeepWith from 'lodash/cloneDeepWith';

export function sortProp(objects, prop) {
    return objects.sort((a, b) => {
        return a[prop] - b[
                prop];
    });
}

export function mapProp(objects, prop) {
    return objects.map((obj) => { return obj[prop] });
}


export function tagObj(obj, tags, property = 'tag') {
    var propertyArray = [],
        originalProperty = obj[property];

    tags = arrayed(tags);

    if(originalProperty instanceof Array) {
        propertyArray = obj[property];
    }

    tags.forEach((tag) => {
        if(propertyArray.indexOf(originalProperty) == -1) {
            propertyArray.push(tag);
        }
    });

    obj[property] = propertyArray;
    return propertyArray;
}


export function allowObj(object, allowedValues) {
    var allowed = true;

    iterate(allowedValues, (property, value) => {
        var normalizedValue = arrayed(value);

        if(!(property in object)) {
            allowed = false;
        } else if(allowed) {
            var propertyValue = arrayed(object[property]),
                valueFound = true;

            propertyValue.forEach((value) => {
                if(normalizedValue.indexOf(value) < 0) {
                    valueFound = false;
                }
            });

            allowed = valueFound;
        }
    });

    return allowed;
}

export function hasTags(obj, tags, property = 'tag') {
    var allowedObj = {};
    allowedObj[property] = tags;

    return allowObj(obj, allowedObj);
}

export function filterAllow(objects, allowedValues) {
    if(!objects) { return []; }

    return objects.filter((object) => {
        return allowObj(object, allowedValues);
    });
}

export function countProps(obj) {
    var count = 0;
    for (var k in obj) if (obj.hasOwnProperty(k)) ++count;
    return count;
}

export function iterate(obj, callback) {
    if(obj instanceof Array) {
        obj.forEach(callback);
    }

    if(countProps(obj) < 1) { return; }
    Object.getOwnPropertyNames(obj).forEach((property) => {
        callback(property, obj[property]);
    });
}

export function mapProperty(array, property) {
    return array.map((item) => {
        return item[property];
    });
}


export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
}

export function mergeDeep(target, source) {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else
                    output[key] = mergeDeep(target[key], source[key]);
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
}

export function cloneDeep(source) {
    return mergeDeep({}, source);
}

export function constructConfiguredClass(config, classMap, defaultType = 'default', ...params) {
    if(!('type' in config)) {
        if(!defaultType) {
            throw new Error('Type is not present in config.');
        }

        config =  {
            ...config,
            type: defaultType
        };
    }

    if(!(config.type in classMap)) {
        throw new Error('Config type '+config.type+' is unknown.');
    }

    var constructor = classMap[config.type];

    return new constructor(config, ...params);
}

export function constructConfiguredClasses(configs, classMap, defaultType = 'default') {
    return configs.map((config) => {
         return constructConfiguredClass(config, classMap, defaultType)
    });
}


export function getIndexById(visits, id) {
    return findIndex(visits, { id: id }) ;
}

export function getIndexByIdOrFail(collection, id, ...debugData) {
    var index = getIndexById(collection, id);
    if(index < 0) {
        var msg = 'Object with id '+id+' not found in collection';
        console.error(msg, collection, ...debugData)
        throw new Error(msg);
    }

    return index;
}

export function getById(collection, id, defaultObj = null) {
    var obj = find(collection, { id: id }) ;
    return obj ? obj : defaultObj;
}

export function getByIdOrFail(collection, id, ...debugData) {
    var obj = getById(collection, id);

    if(!obj) {
        var msg = 'Object with id '+id+' not found in collection';
        console.error(msg, collection, ...debugData)
        throw new Error(msg);
    }
    
    return obj;
}


export function updateOrAddById(datas, data) {
    datas = [...datas];

    var index = getIndexById(datas, data.id);

    if(index < 0) {
        datas.push(data);
    } else {
        datas[index] = data;
    }

    return datas;
}

export function identifiedObjExists(visit, visits) {
    return getIndexById(visits, visit.id) > -1;
}

export function getOrFail(obj, prop, msg = null, ...debugArgs) {
    let value = get(obj, prop);

    if(typeof value !== 'undefined') {
        return value;
    }

    // value is not defined, throw error

    if(!debugArgs.length) {
        let keyFragments = prop.split('.').length ? prop.split('.') : [prop],
            prev = obj,
            fragment = null,
            got = '$';

        for(let i = 0; i < keyFragments.length; i++) {
            fragment  = keyFragments[i];

            let current = get(prev, fragment);

            if(typeof current  === 'undefined') { break; }

            prev = current;
            got += '.'+fragment;
        }

        msg = msg ? msg : 'Failed to get "'+fragment+'" at "'+got+'" in';
        // console.error(msg, prev);
    } else {
        msg = msg ? msg : 'Failed to get prop "'+prop+'" in';
        // console.error(msg, ...debugArgs);
    }

    throw new Error(msg);
}

export function objFromKeyValues(props, values) {
    var obj = {},
        i = 0;
    
    forOwn(props, (propValue, propName) => {
        if(i < values.length) {
            propValue = values[i];
        }

        set(obj, propName, propValue);
        
        i++;
    });
    
    return obj;
}

export function prefixKeys(obj, prefix) {
    return mapKeys(obj, (val, key) => prefix+key);
}

/**
 * Change value at key, returning a new object. Old object remains unchanged
 *
 * @param obj
 * @param key
 * @param inject
 * @param defaultValue
 * @returns {*}
 */
export function modify(obj, key, inject, defaultValue = null) {
    let keyFragments = key.split('.'),
        currentKey = '',
        prev = get(obj, key);

    if(isFunction(inject)) {
        inject = inject(get(obj, key, defaultValue));
    }

    if(prev === inject) { return obj; }

    obj = clone(obj);

    for(let i = 0; i < keyFragments.length-1; i++) {
        let keyFragment = keyFragments[i];
        currentKey = currentKey.length ? `${currentKey}.${keyFragment}` : keyFragment;

        set(obj, currentKey, clone(getOrFail(obj, currentKey)));
    }

    set(obj, key, inject);

    return obj;
}

export function compareKeys(obj1, obj2, options = { compareKeys: null, compareFoo: null }) {
    if(isFunction(options)) {
        options = { compareFoo: options };
    } else if (isArray(options)) {
        options = { compareKeys: options }
    }

    let { compareKeys, compareFoo } = options;
    obj1 = obj1 ?? {};
    obj2 = obj2 ?? {};

    if(!compareKeys) { compareKeys = uniq([...keys(obj1), ...keys(obj2)]) }

    for(let key of compareKeys) {
        // console.log('comparing key', key, obj1[key], obj2[key]);

        if(compareFoo) {
            if(!compareFoo(obj1[key], obj2[key], key)) {
                // console.error(`${key} is different.`, obj1[key], obj2[key]);
                return false;
            }
        } else {
            if(obj1[key] !== obj2[key]) {
                // console.error(`${key} is different.`, obj1[key], obj2[key]);
                return false;
            }
        }
    }

    return true;
}

export function diffKeys(obj1, obj2, compareKeys = null) {
    if(!compareKeys) { compareKeys = uniq([...keys(obj1), ...keys(obj2)]) }

    let diff = {};

    obj1 = obj1 ?? {};
    obj2 = obj2 ?? {};


    for(let key of compareKeys) {
        if(obj1[key] !== obj2[key]) {
            diff[key] = { a: obj1[key], b: obj2[key] }
        }
    }

    return diff;
}

export function namespaceKeys(obj, prefix) {
    return mapKeys(obj, (val, key) => camelCase(prefix+'_'+key));
}